import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';

import { getClassNames } from './utils';
import styles from './styles';

function Button(props) {
  // Remove class items from props to be spread.
  const { className, classes, ...spreadProps } = props;

  return (
    <MuiButton {...spreadProps} className={getClassNames(props)}>
      {props.children}
    </MuiButton>
  );
}

Button.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
  customClass: PropTypes.object
};

export default withStyles(styles)(Button);
